import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Container,
  Grid,
  makeStyles,
} from '@material-ui/core';
import StarIcon from '@material-ui/icons/StarBorder';

const useStyles = makeStyles(theme => {
  return {
    '@global': {
      ul: {
        margin: 0,
        padding: 0,
        listStyle: 'none',
      },
    },
    appBar: {
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
    toolbar: {
      flexWrap: 'wrap',
    },
    toolbarTitle: {
      flexGrow: 1,
    },
    link: {
      margin: theme.spacing(1, 1.5),
    },
    heroContent: {
      padding: theme.spacing(8, 0, 6),
    },
    cardHeader: {
      backgroundColor: theme.palette.grey[200],
    },
    cardPricing: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'baseline',
      marginBottom: theme.spacing(2),
    },
    footer: {
      borderTop: `1px solid ${theme.palette.divider}`,
      marginTop: theme.spacing(8),
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      [theme.breakpoints.up('sm')]: {
        paddingTop: theme.spacing(6),
        paddingBottom: theme.spacing(6),
      },
    },
  };
});

const tiers = [
  {
    title: 'Basic',
    price: '0',
    unit: 'חודש',
    description: [
      'כרטיס ביקור ציבורי',
      'פרטי עסק מפורטים',
      'שעות פתיחה',
      '2 רשתות חברתיות',
    ],
    buttonText: 'התחילו בחינם',
    buttonVariant: 'outlined',
  },
  {
    title: 'Pro',
    subheader: 'מומלץ',
    price: '15',
    unit: 'חודש',

    description: [
      'כרטיס ביקור ציבורי',
      'פרטי עסק מפורטים',
      'שעות פתיחה',
      '10 רשתות חברתיות',
    ],
    buttonText: 'התחילו עכשיו',
    buttonVariant: 'contained',
  },
  {
    title: 'Enterprise',
    price: '7',
    unit: 'כרטיס לחודש',
    description: [
      'חבילת כרטיסי ביקור ציבוריים',
      'פרטי עסק מפורטים',
      'שעות פתיחה',
      '10 רשתות חברתיות',
    ],
    buttonText: 'צרו קשר',
    buttonVariant: 'outlined',
  },
];

function Tiers({ className }) {
  const classes = useStyles();
  return (
    <Container maxWidth="md" component="main">
      <Grid container spacing={5} alignItems="flex-end">
        {tiers.map(tier => (
          // Enterprise card is full width at sm breakpoint
          <Grid
            item
            key={tier.title}
            xs={12}
            sm={tier.title === 'Enterprise' ? 12 : 6}
            md={4}
          >
            <Card>
              <CardHeader
                title={tier.title}
                subheader={tier.subheader}
                titleTypographyProps={{ align: 'center' }}
                subheaderTypographyProps={{ align: 'center' }}
                action={tier.title === 'Pro' ? <StarIcon /> : null}
                className={classes.cardHeader}
              />
              <CardContent>
                <div className={classes.cardPricing}>
                  <Typography component="h2" variant="h3" color="textPrimary">
                    ₪{tier.price}
                  </Typography>
                  <Typography variant="h6" color="textSecondary">
                    /{tier.unit}
                  </Typography>
                </div>
                <ul>
                  {tier.description.map(line => (
                    <Typography
                      component="li"
                      variant="subtitle1"
                      align="center"
                      key={line}
                    >
                      {line}
                    </Typography>
                  ))}
                </ul>
              </CardContent>
              {/* <CardActions>
                    <Button
                      fullWidth
                      variant={tier.buttonVariant}
                      color="primary"
                    >
                      {tier.buttonText}
                    </Button>
                  </CardActions> */}
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}

export default Tiers;
